import { useSessionStore } from 'stores/session';
import Candidate from 'core/models/candidate';
import { useHistory } from 'react-router-dom';
import { isAfter } from 'date-fns';

export const useIsPremium = (): boolean => {
    const user = useSessionStore((s) => s.user) as Candidate | null;
    const history = useHistory();

    if (!user) {
        history.push('/login');
        return false;
    }

    const { hasPaid, isB2C, trialEndDate } = user;

    const userB2CWithActiveTrial = isB2C && trialEndDate && isAfter(new Date(trialEndDate), new Date());
    const userB2CWithSubscription = isB2C && hasPaid;
    const userNotB2C = !isB2C;

    return userB2CWithSubscription || userB2CWithActiveTrial || userNotB2C;
};
